export const notificationTypeEnum = {
    NOSHOW: '',
    ERROR: 'error',
    SUCCESS: 'success'
}